export interface CompanyFeatures {
  showCompanyDropdown: boolean;
  showFeedbacks: boolean;
  showHeatmap: boolean;
  showForceUpdate: boolean;
  showReferral: boolean;
  showPaymentDueDate: boolean;
  showTruckLimitBlock: boolean;
  showChangeLimitButton: boolean;
  showActiveFilter: boolean;
}

const defaultFeatures: CompanyFeatures = {
  showCompanyDropdown: true,
  showFeedbacks: true,
  showHeatmap: true,
  showForceUpdate: true,
  showReferral: true,
  showPaymentDueDate: true,
  showTruckLimitBlock: true,
  showChangeLimitButton: true,
  showActiveFilter: true,
};

const companyConfigs: Record<string, Partial<CompanyFeatures>> = {
  rtelogs: {
    showCompanyDropdown: false,
    showFeedbacks: false,
    showHeatmap: false,
    showForceUpdate: false,
    showReferral: false,
    showPaymentDueDate: false,
    showTruckLimitBlock: true,
    showChangeLimitButton: false,
    showActiveFilter: false,
  }
};

const companyKey = process.env.REACT_APP_COMPANY ?? "";

export const companyFeatures: CompanyFeatures = {
  ...defaultFeatures,
  ...(companyConfigs[companyKey] ?? {}),
};
